import "alpine-turbo-drive-adapter"
import Alpine from "alpinejs"
window.Alpine = Alpine
Alpine.start()
